export default __webpack_public_path__ + "static/media/reserve-wide.4b843f91.png";